import React from "react";
import numeral from "numeral";
import moment from "moment";

import { Modal, Popover, OverlayTrigger } from "react-bootstrap";
import { Button, TileTitle, TileSubtitle, Tile, TileBody, TileItem } from "aible";
import { LineInput } from "components/Inputs/LineInput";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBullseye,
  faTrash,
  faSyncAlt,
  faCheckCircle,
  faUser,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import uploadDatasetIcon from "images/tileIcons/uploadDataset.svg";
import tableauIcon from "images/tableau.png";
import trayIcon from "images/tray_io_logo.png";

import datasetWhiteIcon from "images/tileIcons/dataset_white.svg";
import refreshWhiteIcon from "images/tileIcons/refresh_white.svg";
import targetWhiteIcon from "images/tileIcons/target_white.svg";

import CheckCircleIcon from "images/EDG/CheckCircleIcon.svg";
import RadioIcon from "images/EDG/RadioIconWhite.svg";
import ExploreIcon from "images/EDG/ExploreIconWhite.svg";
import StarIcon from "images/EDG/StarIcon.svg";
import DateIcon from "images/EDG/DateIcon.svg";
import BookIcon from "images/EDG/BookIcon.svg";
import ChatBubbleIcon from "images/EDG/ChatBubbleIcon.svg";
import UserIcon from "images/EDG/UserIcon.svg";
import CombineIcon from "images/EDG/CombineIcon.svg";
import BlueprintIcon from "images/tileIcons/blueprint_white.svg";

import { getDatasetNeedsReindex } from "containers/Upload/reducer";

import styles from "./style.module.css";

export default class DataTile extends React.PureComponent {
  render() {
    const { data, isAiReady, onClick, handleDelete, shouldHightlight } = this.props;

    const isMocked = data && data.isMockedCatalog ? true : false;
    const isJIT = data && data.jId !== undefined;
    const isExamined = data && data.target !== undefined && data.target !== null;
    const isError = data && data.errors && data.errors.length > 0;

    return (
      <div
        className={
          styles.datasetTile + " " + shouldHighlight === true
            ? styles.dHighlight
            : shouldHighlight === false
              ? styles.dHighlightNone
              : ""
        }
        onClick={onClick}
      >
        <div
          className={styles.tileHeader}
          title={data ? data.label : ""}
          style={
            isMocked
              ? { background: "#F2F3F7", color: "#868595" }
              : isError
                ? { background: "#C03E5A" }
                : isAiReady
                  ? { background: "#501B8C" }
                  : isExamined
                    ? { background: "#7E69D7" }
                    : isJIT
                      ? { background: "#3B76EF" }
                      : {}
          }
        >
          {data ? data.label : ""}
          <span className={styles.delete}>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                handleDelete();
              }}
              style={{ padding: "4px" }}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </span>
        </div>
        {data && data.dataset_status && data.dataset_status === "RUNNING" ? (
          <div className={styles.dLoad}>
            {"Importing Dataset..."}
            <LoadingIndicator style={{ margin: "0px", marginTop: "10px" }} />
          </div>
        ) : isError ? (
          <div className={styles.dLoad}>
            {"Error"}
            <div className={styles.eMsg}>
              {data && data.errors && data.errors.length > 0 ? data.errors[0].message : ""}
            </div>
          </div>
        ) : (
          <div className={styles.dContent}>
            <div className={styles.iconRow}>
              <div className={styles.dIcon} style={{ background: "#63C7FF" }}>
                <img src={CheckCircleIcon} />
                <span className={styles.dIconSpan}>{"2"}</span>
              </div>
              <div className={styles.dIcon} style={isJIT && !isMocked ? { background: "#3B76EF" } : {}}>
                <img src={BlueprintIcon} />
              </div>
              <div className={styles.dIcon} style={isExamined && !isMocked ? { background: "#7E69D7" } : {}}>
                <img src={ExploreIcon} />
                <span className={styles.dIconSpan}>{isExamined && !isMocked ? "1" : ""}</span>
              </div>
              <div className={styles.dIcon} style={isAiReady && !isMocked ? { background: "#501B8C" } : {}}>
                <img src={RadioIcon} />
                <span className={styles.dIconSpan}>{isAiReady && !isMocked ? "1" : ""}</span>
              </div>
            </div>
            <div className={styles.dInfo}>
              <div className={styles.infoHighlight} style={{ textTransform: "uppercase" }}>
                <div className={styles.infoIcon}>
                  <img src={BookIcon} />
                </div>
                {(data && data.fields ? Object.keys(data.fields).length : "") +
                  " cols, " +
                  (data && data.rowCount ? numeral(data.rowCount).format("0.0a") : "") +
                  " rows"}
              </div>
              {isMocked === true ? (
                <div className={styles.infoHighlight}>
                  <div className={styles.infoIcon}>
                    <img src={CombineIcon} />
                  </div>
                  {"7 related tables"}
                </div>
              ) : (
                <div className={styles.infoHighlight}>
                  <div className={styles.infoIcon}>
                    <img src={StarIcon} />
                  </div>
                  {"2 Followers, 14 Views"}
                </div>
              )}
              {isMocked === true ? (
                <div />
              ) : (
                <div>
                  <div className={styles.infoHighlight} style={{ marginBottom: "2px" }}>
                    <div className={styles.infoIcon}>
                      <img src={ChatBubbleIcon} />
                    </div>
                    {data && data.annotations ? data.annotations.length + " Annotations" : "0 Annotations"}
                  </div>
                  <div
                    className={styles.infoNormal}
                    style={{ marginBottom: "3px" }}
                    title={moment.utc(data.created).local().format("MMMM Do YYYY, h:mm:ss a")}
                  >
                    <div className={styles.infoIcon}>
                      <img src={DateIcon} />
                    </div>
                    <span style={{ marginTop: "3px" }}>{moment.utc(data.created).local().fromNow()}</span>
                  </div>
                  <div className={styles.infoNormal}>
                    <div className={styles.infoIcon}>
                      <img src={UserIcon} />
                    </div>
                    <span style={{ marginTop: "2px" }}>
                      {data && data.created_by && data.created_by.fullname ? data.created_by.fullname : ""}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}
